<template>
  <section class="flex gap-x-6">
    <NuxtLinkLocale
      v-for="(item, index) in deviceOptions"
      :key="index"
      :to="item.href"
      class="flex flex-col items-center"
      @click="() => item.func()"
    >
      <NuxtImg
        :src="item.imageUrl"
        format="webp"
        :class="
          twJoin(
            'w-[64px] h-[64px] md:w-[120px] md:h-[120px] min-w-[64px] min-h-[64px] md:min-w-[120px] md:min-h-[120px] border border-border-divider rounded-2xl',
            route.fullPath
              .replace('/en', '')
              .replace('/th', '')
              .includes(item.href) && 'border-primary-tangerine border-[3px]'
          )
        "
        :alt="
          item.labelEn?.toString()?.toLowerCase() ??
          item.labelTh?.toString()?.toLowerCase()
        "
      />
      <h2 class="text-sm md:text-base font-bold text-center mt-2">
        {{
          locale == 'en'
            ? item.labelEn || ''
            : item.labelTh || item.labelEn || ''
        }}
      </h2>
    </NuxtLinkLocale>
  </section>
</template>

<script lang="ts" setup>
// TODO: revise script code
import { first } from 'lodash-es'
import { twJoin } from 'tailwind-merge'

const route = useRoute()
const { locale } = useI18n()

// 'devices' | 'personalization' | 'styles' | 'products' | 'blogs'
withDefaults(
  defineProps<{
    pageType: string
  }>(),
  {
    pageType: 'products'
  }
)

const state = useProductFilterStore()
const { toggle, clear } = useProductFilterStore()
const { facetData } = storeToRefs(state)

const _handleFindMatchesFacet = (query: Record<string, string>) => {
  const matches = findMatchesFacet(query, facetData.value)
  const firstMatch = first(matches)
  if (firstMatch) {
    clear()
    toggle(firstMatch)
  }
}

const deviceOptions = [
  {
    labelEn: 'All Phone Cases',
    labelTh: 'เคสโทรศัพท์ทั้งหมด',
    href: `/products/cases`,
    // href: `/${props.pageType}?product_type=Cases`,
    func: () => {
      // handleFindMatchesFacet({ product_type: 'Cases' })
    },
    imageUrl: '/images/iPhone_New Section.png'
  },
  {
    labelEn: 'All iPad Cases',
    labelTh: 'เคสไอแพดทั้งหมด',
    href: `/products/ipad`,
    // href: `/${props.pageType}?product_device=iPad`,
    func: () => {
      // handleFindMatchesFacet({ product_device: 'iPad' })
    },
    imageUrl: '/images/iPad_New Section.png'
  },
  {
    labelEn: 'All Earbud Cases',
    labelTh: 'เคสหูฟัง',
    href: `/products/airpods`,
    // href: `/${props.pageType}?product_device=AirPods`,
    func: () => {
      // handleFindMatchesFacet({ product_device: 'AirPods' })
    },
    imageUrl: '/images/Airpod_New Section.png'
  },

  {
    labelEn: 'All Accessories',
    labelTh: 'อุปกรณ์เสริมทั้งหมด',
    href: `/products/accessories`,
    // href: `/${props.pageType}?product_type=Accessories`,
    func: () => {
      // handleFindMatchesFacet({ product_type: 'Accessories' })
    },
    imageUrl: '/images/Wallet_New Section.png'
  }
]
</script>
